import { render, staticRenderFns } from "./selectBasis.vue?vue&type=template&id=452c2816&scoped=true"
import script from "./selectBasis.vue?vue&type=script&lang=ts"
export * from "./selectBasis.vue?vue&type=script&lang=ts"
import style0 from "./selectBasis.vue?vue&type=style&index=0&id=452c2816&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452c2816",
  null
  
)

export default component.exports